export default {
    currentCard:{cardName:"Belirtilmedi"},
    creditCards:[]
}